
import { toggleScroll } from "@/utilities/toggleScroll";
import { get, getAll, getById } from "@/utilities/querySelector";


const header = getById( 'site-header' );
const relativeHeader = get('.site-header__relative', header);
const topBar = getById('top-menu');
// const mobileMenuToggle = getById( 'mobile-menu-toggle' );
// const mobileMenu = getById( 'mobile-menu' );
const mobileMenuToggle = get('[data-mobile-menu-toggle]');
const mobileMenu = get('[data-mobile-menu]');

mobileMenuToggle?.addEventListener( 'click', () => {
    toggleMenu( 'mobile');
} );

mobileMenu?.querySelectorAll( 'a' ).forEach( link => {
    link.addEventListener( 'click', () => {
        closeMenus();
    } );
} );

// topMenuToggle?.addEventListener('click', () => {
//     toggleMenu('top');
// })

// getAll('a', topMenu).forEach(link => {
//     link.addEventListener( 'click', () => {
//         closeMenus();
//     } );
// });

/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu, scroll = false ) {
    header?.setAttribute( 'data-menu-active', menu );
    toggleScroll( scroll );
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
// const scrollIndicator = document.getElementById( 'site-header-scroll-indicator' );
// if ( header && scrollIndicator ) {
//     const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
//     scrollDeterminer.observe( scrollIndicator );
// }

// /**
//  * @param {IntersectionObserverEntry[]} entries
//  *
//  * @return void
//  */
// function headerScrollHandler( entries ) {
//     entries.forEach( entry => {
//         header?.toggleAttribute( 'data-scrolled', !entry.isIntersecting );
//     } );
// }

/**
 * Debounce function to limit the frequency of function calls
 * @param {Function} func - The function to debounce
 * @param {number} wait - The debounce delay in milliseconds
 * @return {Function} - The debounced function
 */
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const scrollIndicator = getById('site-header-scroll-indicator');
if (header && scrollIndicator) {

    const handleScroll = () => {
        if (window.scrollY > relativeHeader.offsetHeight) {
            header.setAttribute('data-scrolled', 'true');
        } else {
            header.removeAttribute('data-scrolled');
        }
    }

    // const debouncedHandleScroll = debounce(handleScroll);
    window.addEventListener('scroll', handleScroll);
}